export default function convertNullToUndefined(value: any): any {
  return value === null ? undefined : value;
}